module.exports = __webpack_public_path__ + "novidades.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/novidades.png
 ** module id = 753
 ** module chunks = 0
 **/